import { ApiConnector } from '@/api/api.connector';

import type {
  ITemplate,
  ITemplateDto
} from '../pages/Reports/types/reports.types';

class ReportsApi extends ApiConnector {
  getTemplates(): Promise<ITemplate[]> {
    return this.call({ path: 'utils/templates' });
  }

  createTemplate(body: ITemplateDto): Promise<ITemplate> {
    return this.call({
      path: 'utils/templates/create',
      method: 'post',
      body
    });
  }

  redactTemplate(templateId: string, body: ITemplateDto): Promise<ITemplate> {
    return this.call({
      path: `utils/templates/${templateId}/updateTemplate`,
      method: 'patch',
      body
    });
  }

  downloadTemplate(body: {
    template: string;
    type: string;
    values: string;
  }): Promise<string> {
    return this.call({
      path: 'utils/xlsx_template_generate',
      method: 'post',
      body
    });
  }

  downloadPdfTemplate(body: {
    template: string;
    values: string;
    pdf_convert: boolean;
    margin?: {
      top?: number;
      right?: number;
      bottom?: number;
      left?: number;
    };
  }): Promise<Blob> {
    return this.call({
      path: 'utils/pdf_generate',
      method: 'post',
      body
    });
  }
}

export const reportsApi = new ReportsApi();
